import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';

import {userPageHeader, userPageHeaderId} from './user-page-header.module.styl';


export const UserPageSkeleton = () => (
    <Group className={userPageHeader}>
        <SkeletonItem circle={true} width={36} height={36}/>
        <Typography variant="heading-level-1"><SkeletonItem width={250} height={36}/></Typography>
        <Group className={userPageHeaderId}>
            <SkeletonItem width={105} height={26}/>
        </Group>
        <SkeletonItem width={16} height={16}/>
    </Group>
);
